export const updateOperation = (operation, selectedItem, isUnique) => ({
    ...operation,
    type_id: selectedItem.id,
    custom_type_id: selectedItem.type_id,
    category_text: selectedItem.name,
    is_unique: !isUnique,
});

export const processOperations = (data, item, selectedItem, isUnique) => {
    let commentToMatch = '';

    const updatedData = data.map(year => ({
        ...year,
        months: year.months.map(month => ({
            ...month,
            dates: month.dates.map(date => ({
                ...date,
                items: date.items.map(operation => {
                    if (item.id === operation.id) {
                        const updated = updateOperation(operation, selectedItem, isUnique);
                        if (operation.comment) commentToMatch = operation.comment.trim();
                        return updated;
                    }
                    return operation;
                }),
            })),
        })),
    }));

    return { updatedData, commentToMatch };
};

export const updateMatchingComments = (data, comment, selectedItem, isUnique) => {
    if (!comment) return data;

    return data.map(year => ({
        ...year,
        months: year.months.map(month => ({
            ...month,
            dates: month.dates.map(date => ({
                ...date,
                items: date.items.map(operation => {
                    const shouldUpdate = (
                        operation.comment &&
                        comment?.toLowerCase() === operation.comment?.toLowerCase() &&
                        isUnique &&
                        (operation.is_unique === undefined || operation.is_unique === '' ? true : !operation.is_unique)
                    );
                    return shouldUpdate ? updateOperation(operation, selectedItem, isUnique) : operation;
                }),
            })),
        })),
    }));
};